export default {
    install: (app, options) => {
        app.config.globalProperties.$config = key => {
            return window.config[key] || '';
        };
    }
}
